'use strict';

var R, defaultErrorFn;

R = require('ramda');

defaultErrorFn = function defaultErrorFn() {
  return console.error(arguments);
};

module.exports = {
  observeStream: function observeStream(stream, onValueFn, onErrorFn) {
    this._cancelObservers || (this._cancelObservers = []);
    this._cancelObservers.push(stream.onValue(onValueFn));
    return this._cancelObservers.push(stream.onError(onErrorFn || defaultErrorFn));
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._cancelObservers) {
      return R.map(R.call, this._cancelObservers);
    }
  }
};